import { GridLoadResponse } from './load-grid-resource.model';

export enum LoadMasterSubmitGridRequestKeys {
  loadOptions = 'loadOptions',
}

export interface LoadMasterSubmitGridRequest {
  [LoadMasterSubmitGridRequestKeys.loadOptions]?: Record<string, unknown>;
}

export type LoadMasterSubmitGridResponse = GridLoadResponse;

